import { Plan } from '../models/plans';

/**
 * The plan's RRP: its full monthly price, which is what the customer is
 * billed once every discount has run out. Unknown on plans from before the
 * RRP was recorded.
 */
export const planRRP = (plan: Plan): number | undefined => {
  const rrp = Number(plan?.rrp);
  return Number.isFinite(rrp) && rrp > 0 ? rrp : undefined;
};

const dollars = (n: number): string => (Number.isInteger(n) ? String(n) : n.toFixed(2));

/**
 * What the customer is billed after the discount, in words. With the
 * promoPricing flag off (the default) it is the wording from before the RRP
 * was shown, with no figure.
 */
export const afterDiscountRate = (plan: Plan, promoPricing = false): string => {
  const rrp = promoPricing ? planRRP(plan) : undefined;
  return rrp === undefined
    ? 'the standard retail rate'
    : `the standard retail rate of $${dollars(rrp)} per month`;
};

/**
 * Whether the price the customer starts on is below the RRP it reverts to,
 * and so whether to say what happens after the promotional period. Never
 * with the promoPricing flag off: the page reads as before.
 */
export const revertsToRRP = (plan: Plan, startingCost: number, promoPricing = false): boolean => {
  const rrp = promoPricing ? planRRP(plan) : undefined;
  return rrp !== undefined && startingCost < rrp;
};
